import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dialog, DialogContent, DialogTitle, MenuItem, DialogActions } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

const EditPopup = ({ open, onClose, groups, onSubmit, selectedGroupId }) => {
  const [groupId, setGroupId] = useState(selectedGroupId || "");

  const handleSave = () => {
    onSubmit(groupId);
    onClose();
  };

  return (
    // <Dialog
    //   open={open}
    //   onClose={onClose}
    //   maxWidth="xs"
    //   fullWidth
    //   PaperProps={{
    //     sx: {
    //       borderRadius: "16px",
    //       p: 2,
    //     },
    //   }}
    // >
    //   <DialogTitle sx={{ pb: 1 }}>
    //     <MDTypography variant="h6" fontWeight="medium" color="info">
    //       Assign a Group
    //     </MDTypography>
    //   </DialogTitle>

    //   <DialogContent>
    //     <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
    //       <MDInput
    //         select
    //         fullWidth
    //         label="Select the Group"
    //         value={groupId}
    //         onChange={(e) => setGroupId(e.target.value)}
    //       >
    //         {groups.map((grp) => (
    //           <MenuItem key={grp.groupId} value={grp.groupId}>
    //             {grp.groupName}
    //           </MenuItem>
    //         ))}
    //       </MDInput>
    //     </MDBox>
    //   </DialogContent>

    //   <MDBox display="flex" justifyContent="flex-end" gap={1} px={3} pb={2}>
    //     <MDButton
    //       variant="outlined"
    //       color="secondary"
    //       onClick={onClose}
    //       sx={{ textTransform: "none", borderRadius: "10px" }}
    //     >
    //       Close
    //     </MDButton>
    //     <MDButton
    //       variant="gradient"
    //       color="info"
    //       onClick={handleSave}
    //       sx={{ textTransform: "none", borderRadius: "10px", px: 3 }}
    //     >
    //       Submit
    //     </MDButton>
    //   </MDBox>
    // </Dialog>
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          p: 1,
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <MDTypography variant="h6" fontWeight="medium" color="info">
          Assign a Group
        </MDTypography>
      </DialogTitle>

      <DialogContent sx={{ pt: 1 }}>
        <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
          <MDInput
            select
            fullWidth
            variant="outlined"
            label="Select the Group"
            value={groupId}
            onChange={(e) => setGroupId(e.target.value)}
            InputLabelProps={{ shrink: true }}
            SelectProps={{
              displayEmpty: true,
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                height: 38,
              },
              "& .MuiSelect-select": {
                display: "flex",
                alignItems: "center",
                paddingTop: "14px",
                paddingBottom: "14px",
              },
            }}
          >
            {groups.map((grp) => (
              <MenuItem key={grp.groupId} value={grp.groupId}>
                {grp.groupName}
              </MenuItem>
            ))}
          </MDInput>
        </MDBox>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, pt: 0 }}>
        <MDButton
          variant="outlined"
          color="secondary"
          onClick={onClose}
          sx={{ textTransform: "none", borderRadius: "10px" }}
        >
          Close
        </MDButton>
        <MDButton
          variant="gradient"
          color="info"
          onClick={handleSave}
          sx={{ textTransform: "none", borderRadius: "10px", px: 3 }}
        >
          Submit
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

EditPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      groupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      groupName: PropTypes.string.isRequired,
    })
  ).isRequired,
  onSubmit: PropTypes.func.isRequired,
  selectedGroupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default EditPopup;
